import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { IMAGE_SPECS, preparePdfContent, getPdfColumnStyles, formatAppliedFilters } from './core'

export const exportGridToPDF = async (options = {}) => {
  const filename = options.filename || 'relatorio_dados.pdf';
  const title = options.title || 'Relatório de Dados';

  const pdf = new jsPDF('l', 'mm', 'a4');

  const columnsList = options.columns || [];
  const dataResult = options.filteredData || [];

  const exportColumns = columnsList.filter((col) =>
    (col.Export !== 'False' && col.Export !== false)
  );

  const headers = exportColumns.map((c) => c.header);

  const { tableData, imageMap, imageColumnIndexes } = await preparePdfContent(
    dataResult,
    exportColumns
  );

  pdf.setFontSize(16);
  pdf.text(title, 14, 15);
  pdf.setFontSize(10);
  
  let yPosition = 22;
  pdf.text(`Total: ${dataResult.length} registros`, 14, yPosition);
  
  // Adicionar filtros aplicados se existirem
  const filtersText = formatAppliedFilters(options.appliedFilters);
  if (filtersText) {
    yPosition += 5;
    pdf.setFontSize(9);
    pdf.text(`Filtros aplicados: ${filtersText}`, 14, yPosition);
    yPosition += 3;
  }

  const { IMAGE_SIZE, IMAGE_COL_WIDTH, IMAGE_MIN_ROW_HEIGHT } = IMAGE_SPECS;
  const columnStyles = getPdfColumnStyles(imageColumnIndexes, IMAGE_COL_WIDTH, exportColumns);

  autoTable(pdf, {
    head: [headers],
    body: tableData,
    startY: filtersText ? yPosition + 8 : 27,
    margin: { top: 27, right: 10, bottom: 15, left: 10 },
    pageBreak: 'auto',
    styles: { fontSize: 7, cellPadding: 1, overflow: 'ellipsize', cellWidth: 'auto' },
    columnStyles,
    headStyles: { fillColor: [66, 139, 202], textColor: 255, fontSize: 8, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    didParseCell: (data) => {
      if (data.section === 'body' && imageColumnIndexes.has(data.column.index)) {
        data.cell.styles.minCellHeight = Math.max(
          data.cell.styles.minCellHeight || 0,
          IMAGE_MIN_ROW_HEIGHT
        );
      }
    },
    didDrawCell: (data) => {
      if (data.section !== 'body') return;
      const { cell } = data;
      const key = `${data.row.index}-${data.column.index}`;
      const dataUrls = imageMap.get(key);
      if (Array.isArray(dataUrls) && dataUrls.length) {
        try {
          const padding = 1.5;
          const maxH = cell.height - padding * 2;
          const maxW = cell.width - padding * 2;
          const count = dataUrls.length;
          const gap = 1;
          const perSize = Math.min(IMAGE_SIZE, maxH, (maxW - gap * (count - 1)) / count);
          const totalW = perSize * count + gap * (count - 1);
          const startX = cell.x + (cell.width - totalW) / 2;
          const y = cell.y + (cell.height - perSize) / 2;
          for (let i = 0; i < count; i++) {
            const x = startX + i * (perSize + gap);
            const du = dataUrls[i];
            const format = du.startsWith('data:image/png') ? 'PNG' : 'JPEG';
            pdf.addImage(du, format, x, y, perSize, perSize);
          }
        } catch (_) {}
      }
    },
    didDrawPage: (data) => {
      const pageCount = pdf.internal.getNumberOfPages();
      pdf.setFontSize(8);
      pdf.text(
        `Página ${data.pageNumber} de ${pageCount}`,
        pdf.internal.pageSize.width - 30,
        pdf.internal.pageSize.height - 10
      );
    },
  });

  pdf.save(filename);
};

export default exportGridToPDF


